import GeneralSectionComponent from "../generalSectionComponent";
import { BOAT_TYPES_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";
import { getBoatType } from "../../../../redux/directoryMaintenance/boatTypesReducer/actionBoatTypes";
import BoatTypesModal from "./boatTypesModal/BoatTypesModal";

function BoatTypes() {
  return (
    <GeneralSectionComponent
      title={"Типы маломерных судов"}
      headerColumns={BOAT_TYPES_COLUMNS}
      dataFromStateSelector={(state) => state.dictionaryReducer.boatTypes}
      getAction={getBoatType}
      ModalComponent={BoatTypesModal}
    />
  );
}

export default BoatTypes;
